import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  ThemeProvider,
  Dialog,
  DialogContent,
  useTheme
} from "@mui/material";//FB 6997
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetMessageReplies,
  AcknowledgeTestResults,
  GetResultDocuments,
  GetTestResults,
  InsertPPLogs,
} from "../../../../api";//FB 10088
import NavBar from "../../../../components/Navbar";
import { TestResult } from "../../../../store";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import UseStyle from "../../../../css/styles";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LoadingButton } from "@mui/lab";
import { MarkChatRead, MarkChatUnread } from "@mui/icons-material";     //FB 6915

// Update log
// FB  6192   02/06/2023  DK  Added page to handle test results
// FB  6915   06/06/2023  DK  Test results acknowledgement
// FB  7109   07/19/2023  DK  Test results acknowledgement not working
// FB  6997   10/09/2023  SK  Patient Portal: All the api's that shows results in the Patient portal needs fine tuning
// FB  7617   10/20/2023  DK  Add spinner to document view on mobile version
// FB  7681   03/04/2024  KI  Orady - need gear icon on mobile when the doc or any pages are loading
// FB  8584   05/14/2024  SK  Portal Loading takes long for multiple tabs
// FB  8934   09/30/2024  GS  Staff should not have Dr in front of it
// FB  9594   11/05/2024  DK  Latest test result should show up on the top in portal
// FB  10077  02/13/2025  SK  Patient Portal Issues 2.6.25
// FB  10088  05/15/2025  GS  Allow to send the message from EMR to portal only

export default function TestResults() {
  var JSAlert = require("js-alert");  //FB 7617
  const matches = useMediaQuery("(min-width:600px)");
  const styles = UseStyle();
  const navigate = useNavigate();
  const [testresults, setTestResults] = useState<TestResult[]>();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rowsArray, setRowsArray] = useState([10, 15, 20]);
  const [loaderArray, setLoaderArray] = useState<Array<number>>([]);
  const [loadResultArray, setLoadResultArray] = useState<Array<number>>([]); //FB 7681
  const [isAllowReplies, setAllowReplies] = useState(true);//FB 10088
  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const stylestop = {
    container: {
      width: matches == false ? "250" : "567px",
      border: "1px grey",
      backgroundColor: "white",
      padding: matches == false ? "32px 16px" : "32px 40px",
      height: "auto",
    },
  };

  async function GetTestresults() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.Patient_n != null) {
        //FB 9594 Start
        let results = await GetTestResults(user.Patient_n);
        let results_by_date: any = {};
        let results_by_IsRead: any = [];
        results.forEach((item: any) => {
          let date = new Date(item.TestDate).toLocaleDateString();
          if (!results_by_date[date]) {
            results_by_date[date] = [];
          }
          results_by_date[date].push(item);
        });

        for (var key in results_by_date) {
          results_by_date[key] = [...results_by_date[key]].sort((a, b) => {
            if (a.IsReviewed === b.IsReviewed) {
              return 0; // Maintain original order if read status is the same
            } else if (a.IsReviewed == 1) {
              return 1; // Push read messages down
            } else {
              return -1; // Push unread messages up
            }
          });
          results_by_IsRead.push(results_by_date[key]);
        }

        setTestResults(results_by_IsRead.flat(1));
        //FB 9594 End
      }
    }
  }

  async function LoadTestResult(testresult: any) {
    setLoaderArray([...loaderArray, testresult.DocumentID]);
    const data = await GetResultDocuments(testresult.EMRID);
    if (data != undefined) {
      //FB 7617
      if (window.innerWidth <= 768) {
        JSAlert.alert("File downloaded successfully!", null, JSAlert.Icons.Success);
      }
      var file = new Blob([data], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }
    setLoaderArray(loaderArray.filter((la) => la != testresult.DocumentID));
    InsertPPLogs(
      "Viewing Test Results Records",
      window.location.href,
      userName,
      ""
    );
  }

  async function LoadResultAnnotation(testresult: any) {
    setLoadResultArray([...loadResultArray, testresult.DocumentID]); //FB 7681
    // FB 6915
    // FB 7109
    var data = await AcknowledgeTestResults(testresult.EMRID, testresult.PatientID, testresult.DocumentID);
    navigate("/user/home/resultannotation", { state: testresult });
    setLoadResultArray(loadResultArray.filter((la) => la != testresult.DocumentID)); //FB 7681
    InsertPPLogs(
      "Viewing Test Results Messages",
      window.location.href,
      userName,
      ""
    );
  }
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  async function InsertLogs() {
    InsertPPLogs("Viewing Test Results", window.location.href, userName, "");
  }

  //FB 6997 - Begin
  const [showSpinner, setShowSpinner] = useState(false);
  const [messagesEnabled, setMessagesEnabled] = useState(false);// FB  10077
  const theme = useTheme();
  //FB 6997 - End

  useEffect(() => {
    setShowSpinner(true);//FB 6997
    GetMessageReplies().then(setAllowReplies);//FB 10088
    // FB  10077 - Begin
    let setting = sessionStorage.getItem("enable_portal_dashboard_options");
    const values = setting?.split(',').map(Number) || [];
    setMessagesEnabled(values.includes(2));
    // FB  10077 - End
    GetTestresults();
    InsertLogs();
    //FB 6997 - Begin
    setTimeout(() => {
      setShowSpinner(false);
    }, 3000);
    //FB 8584
    //FB 6997 - End
  }, []);


  return (
    <>
      {matches && <NavBar />}
      {!matches && (
        <div
          className="row"
          style={{
            paddingLeft: "25px",
            paddingTop: "16px",
            backgroundColor: "#F5F5F5",
            fontWeight: "bold",
          }}
        >
          Test Results{" "}
          <hr
            style={{ height: "2px", border: "none", backgroundColor: "black" }}
          ></hr>
        </div>
      )}
      <Grid
        container
        spacing={2}
        marginBottom="20px"
        marginTop="0.5px"
        style={
          matches == false
            ? {
              backgroundColor: "#F5F5F5",
            }
            : {
              paddingLeft: "80px",
              backgroundColor: "#F5F5F5",
            }
        }
      >
        <Grid
          item
          xs={12}
          style={
            matches == false
              ? {
                marginLeft: "16px",
              }
              : {}
          }
        >
          {" "}
          {matches && (
            <Typography variant="h5">
              <b
                style={{
                  paddingTop: "20px",
                  fontSize: "32px",
                  fontWeight: "700",
                  lineHeight: "40px",
                }}
              >
                Test Results
              </b>
            </Typography>
          )}
          {matches && testresults != undefined && testresults.length > 0 ? (
            <>
              {/* FB  10077 - Begin */}
              <Typography variant="subtitle1">
                Test results are posted as soon as they are available. 
              </Typography>
              {/* FB 10088 */}
              {messagesEnabled && (
              isAllowReplies ? (
                <Typography variant="subtitle1">
                  If you have any follow-up questions, please <a href="/user/home/Messages">message</a> or{" "}
                  <a href="#">call</a> our office.
                </Typography>
              ) : (
                <Typography variant="subtitle1">
                  If you have any follow-up questions, please <a href="#">call</a> our office.
                </Typography>
              ))}
              {/* FB  10077 - End */}
            </>
          ) : (
            <></>
          )}
        </Grid>
        {testresults != undefined && testresults.length > 0 ? (
          matches ? (
            <Grid item>
              <TableContainer
                component={Paper}
                sx={{ height: "510px", width: "1063px", borderRadius: 0 }}
              >
                <Table
                  stickyHeader
                  size="small"
                  aria-label="sticky table"
                  style={{ tableLayout: "fixed" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b>Test type</b>
                      </TableCell>
                      <TableCell>
                        <b>Ordered by</b>
                      </TableCell>
                      <TableCell>
                        <b>Date</b>
                      </TableCell>
                      <TableCell></TableCell>
                      {/* FB 6915 */}
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {testresults
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((testresult) => {
                        return (
                          <TableRow>
                            <TableCell>
                              <LoadingButton
                                className={styles.textbutton}
                                loading={
                                  loaderArray.indexOf(testresult.DocumentID) > -1
                                }
                                loadingPosition="center"
                                loadingIndicator={
                                  <CircularProgress
                                    size={20}
                                    style={{ color: "#083A4D" }}
                                  />
                                }
                                onClick={() => LoadTestResult(testresult)}
                              >
                                {loaderArray.indexOf(testresult.DocumentID) > -1 ? "" : testresult.TestType}
                              </LoadingButton>
                              {/* <Button
                                className={styles.textbutton}
                                onClick={() => LoadTestResult(testresult)}
                              >
                                {testresult.TestType}
                              </Button> */}
                            </TableCell>
                            <TableCell>
                              {/* FB 8934 Removed "Dr. " prefix */}
                              {testresult.Physician
                                ? testresult.Physician
                                : ""}
                            </TableCell>
                            <TableCell>
                              {new Date(testresult.TestDate).toLocaleDateString() + ""}
                            </TableCell>
                            <TableCell>
                              {/* FB 7681 - Start */}
                              <LoadingButton
                                className={styles.textbutton}
                                loading={
                                  loadResultArray.indexOf(testresult.DocumentID) > -1
                                }
                                loadingPosition="center"
                                loadingIndicator={
                                  <CircularProgress
                                    size={20}
                                    style={{ color: "#083A4D" }}
                                  />
                                }
                                onClick={() => LoadResultAnnotation(testresult)}
                              >
                                {/* FB 6915 - Start */}
                                {loadResultArray.indexOf(testresult.DocumentID) > -1 ? "" : (testresult.IsReviewed === 0 ? <MarkChatUnread style={{ color: "#083A4D" }} />
                                  : <MarkChatRead style={{ color: "#083A4D" }} />)}
                              </LoadingButton>
                              {/* FB 7681 - end */}
                            </TableCell>
                            <TableCell>
                              {testresult.IsReviewed === 1 && new Date(testresult.AcknowledgedOn).getFullYear() != 1 ?
                                <Typography style={{ color: "#083A4D" }}>
                                  <b>Reviewed on {new Date(testresult.AcknowledgedOn).toLocaleDateString() + ""}
                                    {" at "}{new Date(testresult.AcknowledgedOn).toLocaleTimeString() + ""}</b>
                                </Typography> : ""}
                            </TableCell>
                            {/* FB 6915 - End */}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                sx={{
                  flexGrow: 1,
                  paddingTop: 2,
                  paddingBottom: 2,
                  maxWidth: "1063px",
                }}
              >
                <Grid container>
                  <Grid item xs={8} display="flex">
                    <Grid container spacing={2} alignItems="center">
                      <Grid item>
                        <span className={styles.TablePagination_text}>
                          Show{" "}
                        </span>
                      </Grid>
                      <Grid item>
                        <select
                          value={rowsPerPage}
                          onChange={(e) => handleChangeRowsPerPage(e)}
                          style={{
                            color: "#083A4D",
                            borderRadius: "5px",
                            padding: "8px, 16px, 8px, 16px",
                          }}
                        >
                          {rowsArray.map((rows) => (
                            <option value={rows}>{rows}</option>
                          ))}
                        </select>
                      </Grid>
                      <Grid item>
                        <span className={styles.TablePagination_text}>
                          {" "}
                          per page
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={4} className={styles.flexend_Grid}>
                    <IconButton
                      onClick={() => setPage(page - 1)}
                      disabled={page === 0}
                      style={{ color: page === 0 ? "" : "#083A4D" }}
                    >
                      <PlayCircleOutlineIcon
                        style={{ transform: "rotate(180deg)" }}
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => setPage(page + 1)}
                      disabled={
                        page >=
                        Math.ceil(
                          (testresults ? testresults.length : 0) / rowsPerPage
                        ) -
                        1
                      }
                      style={{
                        color:
                          page >=
                            Math.ceil(
                              (testresults ? testresults.length : 0) / rowsPerPage
                            ) -
                            1
                            ? ""
                            : "#083A4D",
                      }}
                    >
                      <PlayCircleOutlineIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          ) : (
            <Grid container style={{ paddingLeft: "16px" }}>
              {testresults?.map((elem: any) => (
                <Grid item xs={12} sm={6} md={3}>
                  <Card>
                    <CardContent>
                      {/* FB 7617  */}
                      <LoadingButton
                        className={styles.textbutton}
                        loading={
                          loaderArray.indexOf(elem.DocumentID) > -1
                        }
                        loadingPosition="center"
                        loadingIndicator={
                          <CircularProgress
                            size={20}
                            style={{ color: "#083A4D" }}
                          />
                        }
                        onClick={() => LoadTestResult(elem)}
                      >
                        {loaderArray.indexOf(elem.DocumentID) > -1 ? "" : elem.TestType}
                      </LoadingButton>
                      <Typography style={{ color: "#13607C" }}>
                        {/* FB 8934 Removed "Dr. " prefix */}
                        {elem.Physician}
                      </Typography>
                      <Typography style={{ color: "#13607C" }}>
                        {/* FB 7681 - Start */}
                        <LoadingButton
                          className={styles.textbutton}
                          loading={
                            loadResultArray.indexOf(elem.DocumentID) > -1
                          }
                          loadingPosition="center"
                          loadingIndicator={
                            <CircularProgress
                              size={20}
                              style={{ color: "#083A4D" }}
                            />
                          }
                          onClick={() => LoadResultAnnotation(elem)}
                        >
                          {/* FB 6915 - Start */}
                          {loadResultArray.indexOf(elem.DocumentID) > -1 ? "" : (elem.IsReviewed === 0 ? <MarkChatUnread style={{ color: "#083A4D" }} />
                            : <MarkChatRead style={{ color: "#083A4D" }} />)}
                        </LoadingButton>
                        {/* FB 7681 - end */}
                      </Typography>
                      {elem.IsReviewed === 1 && new Date(elem.AcknowledgedOn).getFullYear() != 1 ?
                        <Typography style={{ color: "#083A4D" }}>
                          <b>Reviewed on {new Date(elem.AcknowledgedOn).toLocaleDateString() + ""}
                            {" at "}{new Date(elem.AcknowledgedOn).toLocaleTimeString() + ""}</b>
                        </Typography> : ""}
                      {/* FB 6915 - End */}
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )
        ) : (
          <div className="card " style={stylesbegin.container}>
            <div
              className="row"
              style={{
                paddingTop: "32px",
                paddingBottom: matches == false ? "265px" : "32px",
                paddingLeft: "10px",
                backgroundColor: "#F5F5F5",
              }}
            >
              <div className="col-sm-6">
                <div className="card" style={stylestop.container}>
                  {/* <div className="card-body"> */}
                  <label
                    className="card-text"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      paddingBottom: "91px",
                      paddingTop: "52px",
                      paddingLeft: matches == false ? "16px" : "40px",
                      height: "24px",
                    }}
                  >
                    When you receive test results, they will be shown here.
                  </label>
                  {/* </div> */}
                </div>
                {/* FB 6997 - Begin */}

                {/* FB 8584 - Begin */}
              </div>
            </div>
          </div>
        )}
      </Grid>
      {/* FB 8584 - End */}
      <ThemeProvider theme={theme}>
        <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
          <DialogContent
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress style={{ color: "#083A4D" }} />
          </DialogContent>
        </Dialog>
      </ThemeProvider>
      {/* FB 8584 - Removed Unused Part of Code */}
    </>
  );
}

const button = {
  container: {
    backgroundColor: "#083A4D",
    color: "white",
  },
};

const stylestart = {
  container: {
    border: "1px grey",
    padding: "40px",
  },
};

const table = {
  container: {
    padding: "20px",
    border: "white",
  },
};

const stylesbegin = {
  container: {
    border: "1px grey",
    backgroundColor: "#F5F5F5",
  },
};
